import React from 'react';
import { useAppContext } from '../../context/AppContext';
import { Users, ArrowRight, CheckCircle } from 'lucide-react';

const AboutUsPage = () => {
  const { setContactFormOpen } = useAppContext();
  
  const scrollToMission = () => {
    const missionSection = document.getElementById('mission-section');
    if (missionSection) {
      missionSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  
  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-900 via-blue-800 to-teal-700 text-white py-20 md:py-32 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>
        
        <div className="container mx-auto px-4 relative">
          <div className="max-w-4xl">
            {/* <div className="mb-6">
              <span className="inline-block bg-yellow-400 text-black px-4 py-2 rounded-md text-sm font-bold uppercase tracking-wide">
                About Us
              </span>
            </div> */}
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              A Premium Technology Partner
            </h1>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed opacity-90">
              We are a premium technology and software engineering partner that enables companies to establish a strategic presence in India.
            </p>
            {/* <p className="text-lg mb-12 leading-relaxed opacity-80">
              Our mission is to help global innovators to scale by leveraging India's world-class talent without the overhead of managing local compliance.
            </p> */}
            
            <div className="flex flex-col sm:flex-row gap-4">
              {/* <button 
                onClick={() => setContactFormOpen(true)}
                className="bg-yellow-400 text-black font-bold py-4 px-8 rounded-md hover:bg-yellow-300 transition-colors inline-flex items-center justify-center group"
              >
                GET IN TOUCH
                <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </button>
              <button 
                onClick={scrollToMission}
                className="border-2 border-white text-white font-bold py-4 px-8 rounded-md hover:bg-white hover:text-green-900 transition-colors"
              >
                Learn More
              </button> */}
            </div>
          </div>
        </div>
      </section>

      {/* Benefit Cards (replaces numeric stats; theme unchanged) */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="text-3xl font-bold text-red-600 mb-2">Deep Talent</div>
              <div className="text-gray-700 text-lg mb-6">
                Access to niche skill sets and Top talent
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="text-3xl font-bold text-red-600 mb-2">Operational Excellence</div>
              <div className="text-gray-700 text-lg mb-6">
                Effective and Agile
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="text-3xl font-bold text-red-600 mb-2">Optimized Cost</div>
              <div className="text-gray-700 text-lg mb-6">
                Efficient and Transparent
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="text-3xl font-bold text-red-600 mb-2">Scalability</div>
              <div className="text-gray-700 text-lg mb-6">
                Adaptive Team Scaling
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section id="mission-section" className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Mission</h2>
              <p className="text-lg mb-6 text-gray-700">
                To bridge the gap between global innovation and India's exceptional engineering talent, providing seamless, scalable solutions that empower businesses to achieve their technological aspirations without the complexities of international expansion.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-lg text-gray-700">Enable global companies to leverage India's talent pool</span>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-lg text-gray-700">Eliminate operational complexities and compliance burdens</span>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-lg text-gray-700">Deliver world-class engineering excellence</span>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="relative rounded-lg h-96 overflow-hidden shadow-lg">
                <img 
                  src="/assets/images/mission.jpg" 
                  alt="Our Mission" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative order-2 lg:order-1">
              <div className="relative rounded-lg h-96 overflow-hidden shadow-lg">
                <img 
                  src="/assets/images/vision.jpg" 
                  alt="Our Vision" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Vision</h2>
              <p className="text-lg mb-6 text-gray-700">
                To become the leading global platform that seamlessly connects innovative companies with India's exceptional engineering talent, fostering technological advancement and economic growth across borders.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-lg text-gray-700">Pioneer innovative collaboration models</span>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-lg text-gray-700">Drive global technology advancement</span>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-lg text-gray-700">Create sustainable economic partnerships</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Core Values</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              The principles that guide our work and define our culture
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white p-8 rounded-xl shadow-sm text-center">
              <div className="bg-blue-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <span className="text-2xl">🎯</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-red-600">Excellence</h3>
              <p className="text-gray-700">We strive for excellence that exceed expectations and drive business success.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-sm text-center">
              <div className="bg-green-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <span className="text-2xl">🤝</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-red-600">Partnership</h3>
              <p className="text-gray-700">We believe in building long-term partnerships based on trust, transparency, and mutual success.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-sm text-center">
              <div className="bg-purple-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <span className="text-2xl">🌍</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-red-600">Timezone edge</h3>
              <p className="text-gray-700">We support 24x7 seamless collaboration.</p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-sm text-center">
              <div className="bg-orange-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <span className="text-2xl">🔒</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-red-600">Integrity</h3>
              <p className="text-gray-700">We maintain the highest standards of professional integrity and ethical business practices in all our interactions.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-sm text-center">
              <div className="bg-red-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <span className="text-2xl">⚡</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-red-600">Agility</h3>
              <p className="text-gray-700">We provide flexible team expansion and capability growth to support evolving business needs.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-sm text-center">
              <div className="bg-teal-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <span className="text-2xl">🌟</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-red-600">Quality</h3>
              <p className="text-gray-700">We are committed to streamlined processes and best practices to ensure high quality.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative bg-gradient-to-r from-green-900 via-blue-800 to-teal-700 text-white py-20">
        <div className="absolute inset-0 opacity-10">
          <div 
            className="absolute inset-0" 
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
            }}
          ></div>
        </div>
        
        <div className="container mx-auto px-4 text-center relative">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Partner with Us?</h2>
          <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
            Let's discuss how we can help you leverage India's exceptional engineering talent to accelerate your business growth.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => setContactFormOpen(true)}
              className="bg-yellow-400 text-black font-bold py-4 px-8 rounded-md hover:bg-yellow-300 transition-colors inline-flex items-center justify-center group"
            >
              START CONVERSATION
              {/* <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" /> */}
            </button>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutUsPage;
